import { Dispatch, Action } from 'redux'
import { UploadedFileListMapDispatchReturnType } from './types/UploadedFileListMapDispatchReturnType'

export const UploadedFileListMapDispatch = (
  _dispatch: Dispatch<Action>
): UploadedFileListMapDispatchReturnType => {
  return {}
}
